@let reiter = aktiv();
<section class="verwendung-card" [attr.data-testid]="testId()">
  <to-section-title [title]="'common.verwendung.titel' | translate" [subtitle]="subtitle()" />
  <div class="verwendung-card__reiter" role="tablist" [attr.aria-label]="'common.verwendung.reiterLabel' | translate">
    @for (tab of tabs(); track tab.id; let i = $index) {
      @let istAktiv = tab.id === reiter.id;
      <button
        #reiterButton
        type="button"
        role="tab"
        class="verwendung-card__tab"
        [class.verwendung-card__tab--aktiv]="istAktiv"
        [id]="tabElementId(tab.id)"
        [attr.data-testid]="tabElementId(tab.id)"
        [attr.aria-selected]="istAktiv"
        [attr.aria-controls]="istAktiv ? testId() + '-panel' : null"
        [attr.tabindex]="istAktiv ? 0 : -1"
        (click)="waehle(tab.id)"
        (keydown)="onKeydown($event, i)"
      >
        <mat-icon class="verwendung-card__icon" aria-hidden="true">{{ tab.icon }}</mat-icon>
        <span class="verwendung-card__label">{{ tab.label }}</span>
        @if (status() === 'bereit') {
          <span class="verwendung-card__count">{{ zahl(tab.eintraege.length) }}</span>
        }
      </button>
    }
  </div>
  <div
    class="verwendung-card__panel"
    role="tabpanel"
    [id]="testId() + '-panel'"
    [attr.data-testid]="testId() + '-panel'"
    [attr.aria-labelledby]="tabElementId(reiter.id)"
  >
    @if (status() === 'bereit') {
      @if (zeigeSuche()) {
        <div class="verwendung-card__suche">
          <mat-icon class="verwendung-card__lupe" aria-hidden="true">search</mat-icon>
          <input
            type="text"
            class="verwendung-card__suchfeld"
            [attr.data-testid]="testId() + '-search'"
            [value]="suchtext()"
            [placeholder]="
              reiter.suchPlatzhalter ?? ('common.verwendung.suchPlatzhalter' | translate: { label: reiter.label })
            "
            [attr.aria-label]="reiter.suchLabel ?? ('common.verwendung.suchLabel' | translate: { label: reiter.label })"
            (input)="onSuche($event)"
          />
        </div>
      }
      <div class="verwendung-card__liste" tabindex="0" [attr.aria-label]="reiter.label">
        @for (eintrag of sichtbar(); track eintrag.id) {
          <a
            class="verwendung-card__zeile"
            [attr.data-testid]="testId() + '-row'"
            [routerLink]="eintrag.ziel.commands"
            [queryParams]="eintrag.ziel.queryParams"
          >
            <code class="verwendung-card__key">{{ eintrag.key }}</code>
            <span class="verwendung-card__titel">{{ eintrag.titel }}</span>
            @if (eintrag.konfiguration; as konfiguration) {
              <app-konfig-pill class="verwendung-card__config" [configuration]="konfiguration" />
            }
          </a>
        } @empty {
          <p class="verwendung-card__leer" [attr.data-testid]="testId() + '-empty'">
            {{ aktiveSuche() ? ('common.verwendung.keinTreffer' | translate) : reiter.leerText }}
          </p>
        }
        @if (gefiltert().length > maxZeilen) {
          <p class="verwendung-card__mehr" [attr.data-testid]="testId() + '-more'">
            {{ 'common.verwendung.mehr' | translate: { max: zahl(maxZeilen), n: zahl(gefiltert().length) } }}
          </p>
        }
      </div>
    } @else {
      <app-details-historie-status
        [status]="status()"
        [fehlerText]="fehlerText() || ('common.verwendung.fehler' | translate)"
        (retry)="erneutVersuchen.emit()"
      />
    }
  </div>
</section>
